<template>
  <fb-default-layout :sidebar-data="sidebarData" :appInfo="appInfo" @logout="handleLogout"
                     @changePassword="$router.push('/update-user-password')"
                     @userCenter="$router.push('/update-user-info')">
    <template #header-right>
      <div class="header">
        <div class="label-item">
          <span>{{$t('地区服务器')}}：</span>
          <el-select v-model="formData.areaDataName" size="mini" @change="handleSelectAreaData">
            <el-option v-for="item in areaDataList" :key="item.code" :value="item.name" :label="item.name" />
          </el-select>
        </div>

        <div class="label-item">
          <span>{{$t('语言')}}：</span>
          <el-select v-model="formData.sysLang" size="mini" @change="handleChangeLang">
            <el-option value="zh" label="简体中文" />
            <el-option value="en"  label="English" />
          </el-select>
        </div>


        <div class="header-dropdown">
          <i style="font-size: 20px" class="iconfont" :class="{'icon-fangdachuangkou': !isFullScreen, 'icon-suoxiaochuangkou': isFullScreen }"
             @click.stop="handleChangeFullScreen"></i>
        </div>


        <el-dropdown :hide-on-click="false" placement="bottom">
            <span class="dropdown">
              <i class="iconfont icon-github" style="font-size: 26px"></i>
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="$router.push('/update-user-info')">{{$t('个人中心')}}</el-dropdown-item>
            <el-dropdown-item @click.native="$router.push('/update-user-password')">{{$t('修改密码')}}</el-dropdown-item>
            <el-dropdown-item @click.native="handleLogout">{{$t('退出登录')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </template>
  </fb-default-layout>
</template>

<script>
import screenfull from 'screenfull';
import {request} from "@/config/request";

export default {
  name: "Index",
  components: {},
  data() {
    return {
      appInfo: {},
      sidebarData: [],
      isFullScreen: false,
      areaDataList: [],
      formData: {
        areaDataName: "",
        sysLang: "zh"
      }
    }
  },
  methods: {
    // 切换语言
    handleChangeLang(e) {
      window.sessionStorage.setItem("sysLang", e);
      this.$i18n.locale = e;
    },

    handleSelectAreaData(e) {
      window.sessionStorage.setItem("areaData", e);
      this.$router.push('/');
    },
    // 加载数据源列表
    async loadAreaList() {
      try {
        let res = await request(this.$api.areaData.findByUser, {onPage: false});
        this.areaDataList = res.areaDatas;
        if(!this.areaDataList.length) return;
        const areaKey = sessionStorage.getItem("areaData");
        if(!areaKey) {
          const target = this.areaDataList.find(item => item.isDefault === "yes");
          if(target) {
            this.formData.areaDataName = target.name;
          } else {
            this.formData.areaDataName = this.areaDataList[0].name;
          }
        } else {
          this.formData.areaDataName = areaKey;
        }
        window.sessionStorage.setItem("areaData", this.formData.areaDataName);
      } catch (e) {
        console.error(e);
      }
    },

    handleChangeFullScreen() {
       if (screenfull.enabled) {
         screenfull.toggle();
         this.isFullScreen = !this.isFullScreen;
       }
    },
    handleLogout() {
      let vm = this;
      vm.$http.post(vm.$api.auth.logout).then(() => {
        sessionStorage.removeItem('login-user-info');
        sessionStorage.removeItem('areaData');
        vm.$router.push('/login');
      })
    }
  },
  created() {
    if (!sessionStorage.getItem('login-user-info')) {
      this.$router.push('/login');
    }

    let vm = this;
    vm.appInfo = window.appInfo;
    //加载菜单
    vm.$http.post(vm.$api.auth.menuTree, vm.$qs.stringify({flag: 'MENU_SIDEBAR'})).then((resp) => {

      if (resp.data.status === 200) {
        vm.sidebarData = resp.data.data.menuTree;
      }
    })

    this.loadAreaList();

    const sysLang = window.sessionStorage.getItem("sysLang");
    this.formData.sysLang = sysLang || "zh";
    this.$i18n.locale = this.formData.sysLang;
  },
}
</script>

<style lang="scss" scoped>

.el-dropdown {
  cursor: pointer;
}

.header {
  display: flex;
  align-items: center;
  column-gap: 24px;
}

.label-item {
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 14px;
}

.dropdown {
  display: flex;
  align-items: center;
  column-gap: 6px;
}

</style>
